import { render, staticRenderFns } from "./selectHospital.vue?vue&type=template&id=054a252e&scoped=true"
import script from "./selectHospital.vue?vue&type=script&lang=ts"
export * from "./selectHospital.vue?vue&type=script&lang=ts"
import style0 from "./selectHospital.vue?vue&type=style&index=0&id=054a252e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054a252e",
  null
  
)

export default component.exports